import { Injectable } from "@angular/core";
import { BreakOrContinueStatement } from "typescript";

import { FvmsMapApiInterface } from "./fvms.map.api.interface";
import { FvmsMapApiVendor } from "./fvms.map.api.vendor.enum";

declare var kakao: any;

export class FvmsMapApiServiceKakao implements FvmsMapApiInterface {
    mapApiVendor:FvmsMapApiVendor = FvmsMapApiVendor.KAKAO;
    mapElement:any;
    mapObject:any;
    mapOption:any = {};
    mapLatLngBounds:any = new kakao.maps.LatLngBounds();
    // mapTypeControl:any = new kakao.maps.MapTypeControl();
    // mapZoomControl:any = new kakao.maps.ZoomControl();
    mapMarkerClusterer:any; //kakao.maps.MarkerClusterer
    mapGeocoder:any = new kakao.maps.services.Geocoder();

    //api 제공사 정보
    public getMapApiVendor():FvmsMapApiVendor {
        return this.mapApiVendor;
    }
    public getMapElement():any{
        return this.mapElement;
    }
    public getMapObject():any{
        return this.mapObject;
    }
    public getMapOption():any{
        return this.mapOption;
    }
    public getMapLatLngBounds():any{
        return this.mapLatLngBounds;
    }
    public getMarkerClusterer():any{
        return this.mapMarkerClusterer;
    }
    public getMapGeocoder():any{
        return this.mapGeocoder;
    }

    //지도 초기화
    public initMapContainer(mapId:string,mapOption:any) {
        try{
            kakao.maps.disableHD();
            if(mapId.indexOf("#") < 0){
                mapId = "#" + mapId;
            }
            this.mapElement = document.querySelector(mapId);
            if(!mapOption){
                mapOption = {};
                mapOption.center = new kakao.maps.LatLng(37.5662335,126.9779025); //지도의 중심좌표(서울시청)
                mapOption.level = 1;
                mapOption.tileAnimation = false;
                mapOption.keyboardShortcuts = true;
            }
            this.mapOption = mapOption;
            this.mapObject = new kakao.maps.Map(this.mapElement,mapOption);
            return this.mapObject;
        }catch(ex){
            console.error("initMapContainer",ex);
        }
        return null;
    }

    // this.mapService.initMapContainer();
    // this.mapService.addControlViewMode();
    // this.mapService.addControlZoom();
    // this.mapService.addControlCopyright();
    // this.mapService.initLatLngBounds();
    // this.mapService.initGeocoder();
    // this.mapService.initMarkerClusterer();

    // 화면사이즈에 맞춰 배경 타일을 다시 그린다
    public relayout(){
        this.mapObject.relayout();
    }

    // 지도에 지도/스카이뷰 버튼 추가
    public addControlViewMode(){
        try{
            let mapTypeControl = new kakao.maps.MapTypeControl();
            this.mapObject.addControl(mapTypeControl, kakao.maps.ControlPosition.TOPLEFT);
        }catch(ex){
            console.error("addControlViewMode",ex);
        }
    }

    // 지도에 축척레벨 선택바 추가
    public addControlZoom(){
        try{
            let mapZoomControl = new kakao.maps.ZoomControl();
            this.mapObject.addControl(mapZoomControl, kakao.maps.ControlPosition.BOTTOMLEFT);
        }catch(ex){
            console.error("addControlZoom",ex);
        }
    }

    // 지도에 카카오로고/축척레벨 정보 추가
    public addControlCopyright(){
        try{
            this.mapObject.setCopyrightPosition(kakao.maps.CopyrightPosition.BOTTOMLEFT, true);
        }catch(ex){
            console.error("addControlCopyright",ex);
        }
    }

    public setZoomLevel(zoomLevel:number){
        try{
            this.mapObject.setLevel(zoomLevel);
        }catch(ex){
            console.error("setZoomLevel",ex);
        }
    }

    public getZoomLevel(){
        try{
            return this.mapObject.getLevel();
        }catch(ex){
            console.error("getZoomLevel",ex);
        }
        return 1;
    }

    public showTraffic(){
        try{
            this.mapObject.addOverlayMapTypeId(kakao.maps.MapTypeId.TRAFFIC);
        }catch(ex){
            console.error("showTraffic",ex);
        }
    }
    
    public hideTraffic(){
        try{
            this.mapObject.removeOverlayMapTypeId(kakao.maps.MapTypeId.TRAFFIC);
        }catch(ex){
            console.error("hideTraffic",ex);
        }
    }

    public getCenter():any{
        try{
            return this.mapObject.getCenter();
        }catch(ex){
            console.error("getCenter",ex);
        }
        return null;
    }

    public setCenter(lat:any,lng:any){
        try{
            this.mapObject.setCenter(new kakao.maps.LatLng(lat, lng));
        }catch(ex){
            console.error("setCenter",ex);
        }
    }

    public initLatLngBounds(){
        try{
            this.mapLatLngBounds = this.createLatLngBounds();
        }catch(ex){
            console.error("initLatLngBounds",ex);
        }
    }

    public createLatLngBounds():any{
        try{
            return new kakao.maps.LatLngBounds();
        }catch(ex){
            console.error("createLatLngBounds",ex);
        }
        return null;
    }

    //지도 전체 범위 설정
    public appendLatLngBounds(position:any){
        try{
            if(position.getLat() < 32.0 || position.getLat() > 43.0){
                return;
            }
            if(position.getLng() < 125.0 || position.getLng() > 131.0){
                return;
            }
            this.mapLatLngBounds.extend(position);
            this.mapObject.setBounds(this.mapLatLngBounds);
        }catch(ex){
            console.error("appendLatLngBounds",ex);
        }
    }

    public appendLatLngBoundsFromList(position:any[]){
        try{
            let minLat = 999;
            let minLng = 999;
            let maxLat = 0;
            let maxLng = 0;
            // 좌하,우상 좌표 구하기
            position.map((item,idx) => {
                if(item.getLat() <= minLat){
                    minLat = item.getLat();
                }
                if(item.getLng() <= minLng){
                    minLng = item.getLng();
                }
                if(item.getLat() >= maxLat){
                    maxLat = item.getLat();
                }
                if(item.getLng() >= maxLng){
                    maxLng = item.getLng();
                }
            });

            let posSW = this.createLatLng(minLat+"",minLng+"");
            let posNE = this.createLatLng(maxLat+"",maxLng+"");
            this.appendLatLngBounds(posSW);
            this.appendLatLngBounds(posNE);
        }catch(ex){
            console.error("appendLatLngBoundsFromList",ex);
        }
    }

    public initGeocoder(){
        try{
            this.mapGeocoder = this.createGeocoder();
        }catch(ex){
            console.error("initGeocoder",ex);
        }
    }

    public createGeocoder():any{
        try{
            return new kakao.maps.services.Geocoder();
        }catch(ex){
            console.error("createGeocoder",ex);
        }
        return null;
    }

    public initMarkerClusterer(){
        try{
            this.mapMarkerClusterer = this.createMarkerClusterer();
        }catch(ex){
            console.error("initMarkerClusterer",ex);
        }
    }

    public createMarkerClusterer():any{
        try{
            return new kakao.maps.MarkerClusterer({
                map: this.mapObject        // 클러스터링 마커를 표시할 지도 객체
                ,markers:[]
                ,averageCenter: true       // 마커들의 좌표 평균을 클러스터 좌표 설정 여부
                ,minLevel: 2          // 클러스터링 할 지도의 최소 레벨 값. 지정한 숫자에 해당하는 레벨 미만에서는 클러스터링 하지 않는다
                ,gridSize: 35
                ,calculator: [100]      // 클러스터 크기를 구분하는 값을 가진 배열 또는 구분값 생성함수 (default : [10, 100, 1000, 10000])
                // 클러스터 마커에 스타일을 설정한다.
                ,styles: [{
                    width: "50px" 
                    ,height: "50px"
                    ,background: "rgba(29, 181, 210, .7)"
                    ,borderRadius: "30px"
                    ,color: "#fff"
                    ,textAlign: "center"
                    ,fontWeight: "bold"
                    ,lineHeight: "51px"
                    ,boxShadow: "1px 2px 3px rgba(0,0,0,.5)"
                }]
            });
        }catch(ex){
            console.error("createMarkerClusterer",ex);
        }
        return null;
    }

    public addMarkersToCluster(markerList:any[]){
        try{
            if(markerList){
                this.mapMarkerClusterer.addMarkers(markerList);
            }
        }catch(ex){
            console.error("addMarkersToCluster",ex);
        }
    }

    public clearCluster(){
        try{
            this.mapMarkerClusterer.clear();
        }catch(ex){
            console.error("clearCluster",ex);
        }
    }

    // 위경도를 받아 포인트 객체 생성
    public createLatLng(lat:string,lng:string):any{
        let position = null;
        try{
            if(!lat || !lng){
                return null;
            }
            if(lat === "0"){
                return null;
            }
            if(lng === "0"){
                return null;
            }

            position = new kakao.maps.LatLng(lat,lng);
            if(position.getLat() < 32.0 || position.getLat() > 43.0){
                return null;
            }
            if(position.getLng() < 125.0 || position.getLng() > 131.0){
                return null;
            }
        }catch(ex){
            console.error("createLatLng",ex);
        }
        return position;
    }

    //마커의 이미지 생성
    public createMarkerImage(imgOption:any):any{
        let markerImg = null;
        try{
            if(!imgOption){
                imgOption = {
                    imgSrc:"https://t1.daumcdn.net/mapjsapi/images/marker.png"
                    ,imgWidth:29
                    ,imgHeight:42
                    ,offsetX:14
                    ,offsetY:42
                };
            }
            let markerImgSize = new kakao.maps.Size(imgOption.imgWidth, imgOption.imgHeight);
            let markerImgOption = {
                offset: new kakao.maps.Point(imgOption.offsetX, imgOption.offsetY)
            };
            markerImg = new kakao.maps.MarkerImage(imgOption.imgSrc, markerImgSize, markerImgOption);
        }catch(ex){
            console.error("createMarkerImage",ex);
        }
        return markerImg;
    }

    //history용 작은 화살표
    public createSvgImgTagArrow(status:string,direction:string,width:number,height:number):any{
        let svgTagPrefix = "data:image/svg+xml;charset=UTF-8,";
        let svgTag = "";
        let classFill = "fill-black";
        let svgWidth = width || 100;
        let svgHeight = height || 100;
        let directionCalc = direction || 0;
        switch(status.toLowerCase()){
            case "error":
                classFill = "fill-danger";
            break;
            case "on":
                classFill = "fill-primary";
            break;
            default:
                classFill = "fill-black";
            break;
        }

        svgTag += "<svg xmlns='http://www.w3.org/2000/svg'";
        svgTag += `    viewBox='0 0 100 100' width='${svgWidth}px' height='${svgHeight}px'>`;
        svgTag += "    <defs>";
        svgTag += "        <style>";
        svgTag += "            .fill-white{fill:#ffffff;}";
        svgTag += "            .fill-gray{fill:#d6d6d6;}";
        svgTag += "            .fill-black{fill:#474747;}";
        svgTag += "            .fill-primary{fill:#007bff;}";
        svgTag += "            .fill-danger{fill:#dc3545;}";
        svgTag += `            .circle-direction{transform:rotate(${directionCalc}deg);transform-origin: 50% 50%}`;
        svgTag += "        </style>";
        svgTag += "    </defs>";

        //배경 원
        svgTag += "    <circle class='fill-white' cx='50' cy='50' r='50'/>";
        //화살표
        svgTag += `    <path class="circle-direction ${classFill}" d="M48,0A50,50,0,0,0,33.53,97.21v-40H20.63A3.41,3.41,0,0,1,18,51.7L47.45,14.9a3.26,3.26,0,0,1,5.1,0L82,51.7a3.41,3.41,0,0,1-2.66,5.54H66.47v40A50,50,0,0,0,48,0Z"/>`;

        svgTag += "</svg>";

        return svgTagPrefix + encodeURIComponent(svgTag);
    }

    public getSvgImgTagCarWithNo(title:string,subTitle:string,status:string,direction:string,width:number,height:number):string{
        let svgTagPrefix = "data:image/svg+xml;charset=UTF-8,";
        let svgTag = "";
        let classFill = "fill-black";
        let svgWidth = width || 100;
        let svgHeight = height || 100;
        let directionCalc = direction || 0;
        switch(status.toLowerCase()){
            case "error":
                classFill = "fill-danger";
                break;
            case "on":
            case "1":
            case "y":
                classFill = "fill-info";
                break;
            default:
                classFill = "fill-secondary";
                break;
        }

        svgTag += "<svg xmlns='http://www.w3.org/2000/svg'";
        svgTag += "    viewBox='0 0 100 100' width='" + svgWidth + "px' height='" + svgHeight + "px'>";
        svgTag += "    <defs>";
        svgTag += "        <style>";
        svgTag += "            .text-box{}";
        svgTag += "            .title{font-size:11px;}";
        svgTag += "            .describe{font-size:10px;}";
        svgTag += "            .bg-trans-7{opacity:0.7;}";
        svgTag += "            .fill-gray      { fill:#c0c0c0; }";
        svgTag += "            .fill-primary   { fill:#7460ee; }";
        svgTag += "            .fill-info      { fill:#2962ff; }";
        svgTag += "            .fill-success   { fill:#36bea6; }";
        svgTag += "            .fill-danger    { fill:#f62d51; }";
        svgTag += "            .fill-warning   { fill:#ffbc34; }";
        svgTag += "            .fill-secondary { fill:#6c757d; }";
        svgTag += "            .fill-dark      { fill:#343a40; }";
        svgTag += "            .fill-indigo    { fill:#6610f2; }";
        svgTag += "            .fill-pink      { fill:#e83e8c; }";
        svgTag += "            .fill-orange    { fill:#fb8c00; }";
        svgTag += "            .fill-white     { fill:#ffffff; }";
        svgTag += "            .fill-black     { fill:#000000; }";
        svgTag += "            .fill-01        { fill:#002e83; }";
        svgTag += "            .stoke-primary  { stroke:#7460ee; }";
        svgTag += "            .stoke-info     { stroke:#2962ff; }";
        svgTag += "            .stoke-success  { stroke:#36bea6; }";
        svgTag += "            .stoke-danger   { stroke:#f62d51; }";
        svgTag += "            .stoke-warning  { stroke:#ffbc34; }";
        svgTag += "            .stoke-secondary{ stroke:#6c757d; }";
        svgTag += "            .stoke-dark     { stroke:#343a40; }";
        svgTag += "            .stoke-indigo   { stroke:#6610f2; }";
        svgTag += "            .stoke-pink     { stroke:#e83e8c; }";
        svgTag += "            .stoke-orange   { stroke:#fb8c00; }";
        svgTag += "            .stoke-white    { stroke:#ffffff; }";
        svgTag += "            .stoke-black    { stroke:#000000; }";
        svgTag += "            .stoke-01       { stroke:#002e83; }";
        svgTag += "            .circle-car{transform:rotate(" + directionCalc + "deg);transform-origin: 50% 23%}";
        svgTag += "        </style>";
        svgTag += "    </defs>";

        //텍스트박스
        svgTag += "    <rect class=' " + classFill + "' y='66' width='100' height='34' rx='1.7'/>";
        svgTag += "    <text class='title fill-white' x='5' y='80'>" + title + "</text>";
        svgTag += "    <text class='describe fill-white' x='5' y='95'>" + subTitle + "</text>";

        //테두리
        svgTag += "    <path class='" + classFill + "' d='M65.91,6.59h0A22.5,22.5,0,0,0,32.55,36.7C33.89,38.35,50,58.5,50,58.5h0S66.11,38.35,67.45,36.7A22.5,22.5,0,0,0,65.91,6.59Z'/>";

        //차모양
        svgTag += "    <path class='fill-white circle-car' d='M50,5A17.87,17.87,0,1,0,67.87,22.9,17.87,17.87,0,0,0,50,5Zm7.49,28.76a2.36,2.36,0,0,1-2.36,2.37H44.87a2.36,2.36,0,0,1-2.36-2.37V14.91a4.64,4.64,0,0,1,2.36-4.05l1.07-.6a8.26,8.26,0,0,1,8.14,0l1.05.6a4.64,4.64,0,0,1,2.36,4.05ZM44.7,23a.43.43,0,0,1,.27-.56A16.88,16.88,0,0,1,50,21.63a16.7,16.7,0,0,1,5,.78.44.44,0,0,1,.28.56l-1.12,3.12a.43.43,0,0,1-.49.27A15.56,15.56,0,0,0,50,25.9a15.73,15.73,0,0,0-3.72.46.42.42,0,0,1-.48-.27Zm2-7.27a.6.6,0,0,1,0-.84L49.58,12a.58.58,0,0,1,.84,0l2.83,2.82a.6.6,0,0,1,0,.84.61.61,0,0,1-.42.17.58.58,0,0,1-.41-.17l-1.83-1.83V19a.58.58,0,0,1-.59.59.59.59,0,0,1-.59-.59V13.87L47.59,15.7A.6.6,0,0,1,46.75,15.7Zm7.76,12.5,1-2.82a.13.13,0,0,1,.22.1v6.7a.13.13,0,0,1-.22.1L54.54,30a.62.62,0,0,1-.08-.33V28.48A.87.87,0,0,1,54.51,28.2Zm-8.92.28v1.17a.62.62,0,0,1-.08.33l-.93,2.3a.13.13,0,0,1-.22-.1v-6.7a.13.13,0,0,1,.22-.1l1,2.82A.87.87,0,0,1,45.59,28.48Zm9.25,4.81a.43.43,0,0,1-.29.52,15,15,0,0,1-9.11,0,.42.42,0,0,1-.28-.52l.52-1.09a.58.58,0,0,1,.51-.32l7.63,0a.55.55,0,0,1,.5.32Z'/>";
        svgTag += "</svg>";
        return svgTagPrefix + encodeURIComponent(svgTag);
    }

    public getSvgImgTagHome(width:number,height:number,color:string):string{
        let svgTagPrefix = "data:image/svg+xml;charset=UTF-8,";
        let svgTag = "";
        let classFill = "fill-black";
        let svgWidth = width || 100;
        let svgHeight = height || 100;

        classFill = `fill-${color}`;
        if(!color){
            classFill = "fill-black";
        }

        svgTag += "<svg xmlns='http://www.w3.org/2000/svg'";
        svgTag += "    viewBox='0 0 44.98 58.48' width='" + svgWidth + "px' height='" + svgHeight + "px'>";
        svgTag += "    <defs>";
        svgTag += "        <style>";
        svgTag += "            .text-box{}";
        svgTag += "            .title{font-size:11px;}";
        svgTag += "            .describe{font-size:10px;}";
        svgTag += "            .bg-trans-7{opacity:0.7;}";
        svgTag += "            .fill-gray      { fill:#c0c0c0; }";
        svgTag += "            .fill-primary   { fill:#7460ee; }";
        svgTag += "            .fill-info      { fill:#2962ff; }";
        svgTag += "            .fill-success   { fill:#36bea6; }";
        svgTag += "            .fill-danger    { fill:#f62d51; }";
        svgTag += "            .fill-warning   { fill:#ffbc34; }";
        svgTag += "            .fill-secondary { fill:#6c757d; }";
        svgTag += "            .fill-dark      { fill:#343a40; }";
        svgTag += "            .fill-indigo    { fill:#6610f2; }";
        svgTag += "            .fill-pink      { fill:#e83e8c; }";
        svgTag += "            .fill-orange    { fill:#fb8c00; }";
        svgTag += "            .fill-white     { fill:#ffffff; }";
        svgTag += "            .fill-black     { fill:#000000; }";
        svgTag += "            .fill-01        { fill:#002e83; }";
        svgTag += "            .stoke-primary  { stroke:#7460ee; }";
        svgTag += "            .stoke-info     { stroke:#2962ff; }";
        svgTag += "            .stoke-success  { stroke:#36bea6; }";
        svgTag += "            .stoke-danger   { stroke:#f62d51; }";
        svgTag += "            .stoke-warning  { stroke:#ffbc34; }";
        svgTag += "            .stoke-secondary{ stroke:#6c757d; }";
        svgTag += "            .stoke-dark     { stroke:#343a40; }";
        svgTag += "            .stoke-indigo   { stroke:#6610f2; }";
        svgTag += "            .stoke-pink     { stroke:#e83e8c; }";
        svgTag += "            .stoke-orange   { stroke:#fb8c00; }";
        svgTag += "            .stoke-white    { stroke:#ffffff; }";
        svgTag += "            .stoke-black    { stroke:#000000; }";
        svgTag += "            .stoke-01       { stroke:#002e83; }";
        svgTag += "        </style>";
        svgTag += "    </defs>";

        svgTag += `<path class="${classFill}" d="m38.39 6.57c-8.79-8.77-23.04-8.76-31.82 0.04-8.13 8.15-8.8 21.13-1.54 30.07 1.34 1.65 17.45 21.8 17.45 21.8s16.11-20.15 17.45-21.8c7.29-8.94 6.62-21.95-1.54-30.11z"/>`;
        svgTag += `<path class="fill-white" d="m4.61 22.85c0 9.87 8.01 17.87 17.87 17.87s17.86-7.98 17.87-17.84c0.02-9.86-7.97-17.88-17.84-17.9h-0.03c-9.86 0-17.87 8.01-17.87 17.87z"/>`;
        svgTag += `<g transform="matrix(.049209 0 0 .049564 -16.986 -3.7403)" class="${classFill}">`;
        svgTag += `    <path d="m877.05 679.63h37.613c10.793 0 19.624-7.904 19.624-17.565v-29.277h-57.237v46.843"/>`;
        svgTag += `    <path d="m914.67 574.24h-37.613v46.843h57.237v-29.277c0-9.6613-8.8307-17.565-19.624-17.565"/>`;
        svgTag += `    <path d="m803.46 662.07c0 9.6613 8.8307 17.565 19.624 17.565h40.884v-46.843h-60.508v29.277"/>`;
        svgTag += `    <path d="m803.46 591.8v29.277h60.508v-46.843h-40.884c-10.793 0-19.624 7.904-19.624 17.565"/>`;
        svgTag += `    <path d="m1035.3 535.38-22.549 20.184c-4.9293 4.412-12.995 4.412-17.924 0l-202.57-181.32-201.34 180.22c-4.928 4.412-12.995 4.412-17.923 0l-22.549-20.184c-4.9293-4.412-4.9293-11.632 0-16.044l233.01-208.57c4.928-4.412 12.995-4.412 17.924 0l22.549 20.184c0.56667 0.508 1.06 1.056 1.496 1.6293l209.87 187.86c4.9293 4.412 4.9293 11.631 0 16.043zm-71.529 198.41c0 9.6613-8.832 17.567-19.625 17.567h-173.35v-159.56c0-9.6613-8.8307-17.565-19.624-17.565h-53.967c-10.793 0-19.624 7.904-19.624 17.565v159.56h-35.979c-10.793 0-19.624-7.9053-19.624-17.567v-175.66c0-0.73867 0.068-1.464 0.16934-2.18-0.54667-2.592 0.25066-5.3853 2.3973-7.3827l161.79-150.53c3.4227-3.184 9.0227-3.184 12.445 0l15.657 14.568c0.39333 0.36667 0.736 0.76267 1.04 1.176l139.34 129.65c2.496 1.4587 4.5907 3.4147 6.1307 5.704l0.252 0.23333c2.016 1.876 2.8107 4.452 2.452 6.9053 0.0733 0.61334 0.11466 1.2333 0.11466 1.8627zm-66.733-389.65c0-3.4707 3.116-6.312 6.924-6.312h78.483c3.808 0 6.924 2.8413 6.924 6.312v10.471c0 3.472-3.116 6.3133-6.924 6.3133h-2.32v90.087l-73.592-61.297v-28.789h-2.5707c-3.808 0-6.924-2.8413-6.924-6.3133zm-96.367-100.75c-163.46 0-296.44 130.94-296.44 291.89 0 160.95 132.98 291.89 296.44 291.89 163.46 0 296.45-130.94 296.45-291.89 0-160.95-132.99-291.89-296.45-291.89"/>`;
        svgTag += `</g>`;

        svgTag += "</svg>";
        return svgTagPrefix + encodeURIComponent(svgTag);
    }

    public getSvgImgTagCluster(title:string,width:number,height:number):string{
        let svgTagPrefix = "data:image/svg+xml;charset=UTF-8,";
        let svgTag = "";
        let classFill = "fill-black";
        let svgWidth = width || 100;
        let svgHeight = height || 200;

        svgTag += "<svg xmlns='http://www.w3.org/2000/svg'";
        svgTag += "    viewBox='0 0 100 100' width='" + svgWidth + "px' height='" + svgHeight + "px'>";
        svgTag += "    <defs>";
        svgTag += "        <style>";
        svgTag += "            .text-box{}";
        svgTag += "            .title{font-size:11px;}";
        svgTag += "            .describe{font-size:10px;}";
        svgTag += "            .bg-trans-7{opacity:0.7;}";
        svgTag += "            .fill-gray      { fill:#c0c0c0; }";
        svgTag += "            .fill-primary   { fill:#7460ee; }";
        svgTag += "            .fill-info      { fill:#2962ff; }";
        svgTag += "            .fill-success   { fill:#36bea6; }";
        svgTag += "            .fill-danger    { fill:#f62d51; }";
        svgTag += "            .fill-warning   { fill:#ffbc34; }";
        svgTag += "            .fill-secondary { fill:#6c757d; }";
        svgTag += "            .fill-dark      { fill:#343a40; }";
        svgTag += "            .fill-indigo    { fill:#6610f2; }";
        svgTag += "            .fill-pink      { fill:#e83e8c; }";
        svgTag += "            .fill-orange    { fill:#fb8c00; }";
        svgTag += "            .fill-white     { fill:#ffffff; }";
        svgTag += "            .fill-black     { fill:#000000; }";
        svgTag += "            .fill-01        { fill:#002e83; }";
        svgTag += "            .stoke-primary  { stroke:#7460ee; }";
        svgTag += "            .stoke-info     { stroke:#2962ff; }";
        svgTag += "            .stoke-success  { stroke:#36bea6; }";
        svgTag += "            .stoke-danger   { stroke:#f62d51; }";
        svgTag += "            .stoke-warning  { stroke:#ffbc34; }";
        svgTag += "            .stoke-secondary{ stroke:#6c757d; }";
        svgTag += "            .stoke-dark     { stroke:#343a40; }";
        svgTag += "            .stoke-indigo   { stroke:#6610f2; }";
        svgTag += "            .stoke-pink     { stroke:#e83e8c; }";
        svgTag += "            .stoke-orange   { stroke:#fb8c00; }";
        svgTag += "            .stoke-white    { stroke:#ffffff; }";
        svgTag += "            .stoke-black    { stroke:#000000; }";
        svgTag += "            .stoke-01       { stroke:#002e83; }";
        svgTag += "        </style>";
        svgTag += "    </defs>";

        svgTag += "    <circle cx='50' cy='50' r='40' stroke='#1C7A84' stroke-width='1'  opacity='0.7' style='fill:#1DB5D2;'/>";
        svgTag += "    <text x='50%' y='50%' text-anchor='middle' font-size='25' font-family='Roboto' font-weight='bold' fill='white' dy='.3em'>";
        svgTag += title;
        svgTag += "    </text>";
        svgTag += "</svg>"

        return svgTagPrefix + encodeURIComponent(svgTag);
    }

    //마커 생성
    public createMarkerFromLatLng(latLng:any,idx:number,imgOption:any):any{
        let defaultMarker = null;
        try{
            let position = latLng;
            if(position.getLat() < 32.0 || position.getLat() > 43.0){
                return null;
            }
            if(position.getLng() < 125.0 || position.getLng() > 131.0){
                return null;
            }
            let markerImg = this.createMarkerImage(imgOption);
            defaultMarker = new kakao.maps.Marker({
                position : latLng
                ,clickable : true
                ,image : markerImg
            });
        }catch(ex){
            console.error("createMarker",ex);
        }
        return defaultMarker;
    }

    public addMarkerEvent(marker:any,eventName:string,callbackFn:any){
        try{
            kakao.maps.event.addListener(marker,eventName,callbackFn);
        }catch(ex){
            console.error("addMarkerEvent",ex);
        }
    }

    public removeMarkerEvent(marker:any,eventName:string,callbackFn:any){
        try{
            kakao.maps.event.removeListener(marker,eventName,callbackFn);
        }catch(ex){
            console.error("removeMarkerEvent",ex);
        }
    }

    public addMapEvent(eventName:string,callbackFn:any){
        try{
            kakao.maps.event.addListener(this.mapObject,eventName,callbackFn);
        }catch(ex){
            console.error("addMapEvent",ex);
        }
    }

    public removeMapEvent(eventName:string,callbackFn:any){
        try{
            kakao.maps.event.removeListener(this.mapObject,eventName,callbackFn);
        }catch(ex){
            console.error("removeMapEvent",ex);
        }
    }

    //마커를 지도에 표시
    public showMarker(marker:any){
        try{
            marker.setMap(this.mapObject);
        }catch(ex){
            console.error("showMarker",ex);
        }
    }

    //마커를 지도에 제거
    public hideMarker(marker:any){
        try{
            if(marker){
                marker.setMap(null);
            }
        }catch(ex){
            console.error("hideMarker",ex);
        }
    }

    //인포윈도우 생성
    public createInfoWindowFromLatLng(latLng:any,iwContent:string):any{
        let infowindow = null;
        try{
            infowindow = new kakao.maps.InfoWindow({
                position: latLng
                ,content: iwContent
                ,removable: true
            });
        }catch(ex){
            console.error("createInfoWindow",ex);
        }
        return infowindow;
    }

    //인포윈도우 표시
    public showInfoWindow(marker:any,infoWindow:any){
        try{
            infoWindow.open(this.mapObject,marker);
        }catch(ex){
            console.error("showInfoWindow",ex);
        }
    }

     //인포윈도우 닫기
    public hideInfoWindow(infoWindow){
        try{
            if(infoWindow){
                infoWindow.close(infoWindow);
            }
        }catch(ex){
            console.error("hideInfoWindow",ex);
        }
    }

    public createPolyLine(lineOption:any):any{
        try{
            return new kakao.maps.Polyline(lineOption);
        }catch(ex){
            console.error("createPolyLine",ex);
        }
        return null;
    }

    public createPolyLineFromList(lineOption:any,listPosition:any[]){
        lineOption.map = this.mapObject;
        lineOption.path = listPosition;
        return new kakao.maps.Polyline(lineOption);
    }

    public hidePolyLine(mapPolyLine){
        if(mapPolyLine){
            mapPolyLine.setMap(null);
        }
    }

    public showPolyLine(mapPolyLine){
        if(mapPolyLine){
            mapPolyLine.setMap(this.mapObject);
        }
    }

    public createCircle(opt):any{
        // new kakao.maps.Circle({
        //     center : centerPosition // 원의 중심좌표입니다
        //     ,radius: centerConf.radius // 원의 반지름입니다 m 단위 이며 선 객체를 이용해서 얻어옵니다
        //     ,strokeWeight: this.strokeWeight // 선의 두께입니다
        //     ,strokeColor: this.strokeColor // 선의 색깔입니다
        //     ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
        //     ,strokeStyle: "solid" // 선의 스타일입니다
        //     ,fillColor: this.fillColor // 채우기 색깔입니다
        //     ,fillOpacity: 0.2  // 채우기 불투명도입니다 
        // });
        try{
            return new kakao.maps.Circle(opt);
        }catch(ex){
            console.error("createCircle",ex);
        }
        return null;
    }

    public createRectangle(opt):any{
        // new kakao.maps.Rectangle({
        //     strokeWeight: this.strokeWeight // 선의 두께입니다
        //    ,strokeColor: this.strokeColor // 선의 색깔입니다
        //    ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
        //    ,strokeStyle: 'solid' // 선의 스타일입니다
        //    ,fillColor: this.fillColor // 채우기 색깔입니다
        //    ,fillOpacity: 0.2  // 채우기 불투명도입니다 
        // });
        try{
            return new kakao.maps.Rectangle(opt);
        }catch(ex){
            console.error("createRectangle",ex);
        }
        return null;
    }

    public createPolygon(opt):any{
        // new kakao.maps.Polygon({
        //     strokeWeight: this.strokeWeight // 선의 두께입니다
        //    ,strokeColor: this.strokeColor // 선의 색깔입니다
        //    ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
        //    ,strokeStyle: 'solid' // 선의 스타일입니다
        //    ,fillColor: this.fillColor // 채우기 색깔입니다
        //    ,fillOpacity: 0.2  // 채우기 불투명도입니다 
        // });
        try{
            return new kakao.maps.Polygon(opt);
        }catch(ex){
            console.error("createPolygon",ex);
        }
        return null;
    }

    public createCustomOverlay(opt):any{
        try{
            return new kakao.maps.CustomOverlay(opt);
        }catch(ex){
            console.error("createCustomOverlay",ex);
        }
        return null;
    }

    // 좌표로 주소 가져오기
    public searchAddrByLatLng(lat:string,lng:string):any{
        let promise = new Promise((resolve,reject) => {
            if(!this.mapGeocoder){
                this.mapGeocoder = this.initGeocoder();
            }
            //lat,lng 반대로 입력 주의
            this.mapGeocoder.coord2Address(lng,lat,function(result, status){
                if (status === kakao.maps.services.Status.OK) {
                    if(result && result.length > 0){
                        let resultAddr = result[0];
                        if(resultAddr.road_address){
                            resolve(resultAddr.road_address.address_name);
                        }else{
                            resolve(resultAddr.address.address_name);
                        }
                    }
                }
            });
        });
        return promise;
    }

    // 주소로 좌표 가져오기
    public searchAddrByAddr(addr:string):any{
        let promise = new Promise((resolve,reject) => {
            if(!this.mapGeocoder){
                this.mapGeocoder = this.initGeocoder();
            }
            this.mapGeocoder.addressSearch(addr,function(result,status,pagination) {
                if (status === kakao.maps.services.Status.OK) {
                    if(result && result.length > 0){
                        let resultAddr = result[0];
                        let tmpLat = resultAddr.y;
                        let tmpLng = resultAddr.x;
                        let tmpLatLng = new kakao.maps.LatLng(tmpLat,tmpLng);
                        resolve(tmpLatLng);
                    }
                }
            });
        });
        return promise;
    }

    public getGeoHashLimit(zoomLevel:number) {
        let hashLimit = 6;
        switch(zoomLevel){
            case 14:
            case 13:
            case 12:
                hashLimit = 3;
                break;
            case 11:
            case 10:
                hashLimit = 4;
                break;
            case 9:
            case 8:
                hashLimit = 5;
                break;
            case 7:
            case 6:
                hashLimit = 6;
                break;
            case 5:
            case 4:
            case 3:
            case 2:
            case 1:
                hashLimit = 0;
                break;
            default:
                hashLimit = 6;
                break;
        }
        return hashLimit;
    }

    checkLatLng(lat:any = 0.0,lng:any = 0.0):boolean{
        try{
            lat = parseFloat(lat);
            lng = parseFloat(lng);
        }catch(ex){
            return false;
        }
        // console.log("checkLatLng",lat,lng);

        if(lat < 32.0 || lat > 43.0){
            return false;
        }
        if(lng < 125.0 || lng > 131.0){
            return false;
        }
        return true;
    }
}